import api from './Api';

export interface IFgtsSugestaoLancamento {
    id: number;
    contaEmpresa: string;
    tipoLancamento: string; // "C" | "D"
    valor: number;
    data: string;
    historico: string | null;
}

export interface IFgtsSugestaoPendente {
    chaveVinculoMatch: string;
    lancamentos: IFgtsSugestaoLancamento[];
    justificativa: string | null;
    origemMatch: string | null;
}

export interface IFgtsConciliacaoDecisao {
    id: number;
    chaveVinculo: string;
    modalidade: string; // "1_1" | "N_1" | "1_N" | "N_N"
    statusFuncional: string;
    reasonCodes: string[];
    scoreValor: number;
    scoreTemporal: number;
    scoreHistorico: number;
    scoreCompetencia: number;
    scoreDocumento: number;
    scoreTotal: number;
    faixaScore: string;
    quantidadeProvisoes: number;
    quantidadeBaixas: number;
    percentualDivergencia: number | null;
    dataCriacao: string;
}

export interface IFgtsAuditoriaEvento {
    id: number;
    chaveVinculo: string | null;
    tipoEvento: string;
    detalhe: string;
    dataCriacao: string;
}

export interface IFgtsStatusResumo {
    status: string;
    quantidade: number;
    valor: number;
}

export interface IFgtsModalidadeResumo {
    modalidade: string;
    quantidade: number;
}

export interface IFgtsLancamentoIndevido {
    lancamentoId: number;
    contaEmpresa: string;
    historico: string | null;
    valor: number;
    data: string;
}

export interface IFgtsRelatorioImportacao {
    quantidadeProvisoes: number;
    valorProvisoes: number;
    quantidadeBaixas: number;
    valorBaixas: number;
    porStatus: IFgtsStatusResumo[];
    porModalidade: IFgtsModalidadeResumo[];
    possiveisLancamentosIndevidos: IFgtsLancamentoIndevido[];
    candidatosAguardandoValidacao: IFgtsSugestaoPendente[];
    pendenciasSemCandidato: number;
}

const FgtsConciliacaoService = {
    buscarRelatorio: async (esteiraId: number): Promise<IFgtsRelatorioImportacao | null> => {
        try {
            const resp = await api.get(`fgts-conciliacao/${esteiraId}/relatorio`);
            return resp.data;
        } catch {
            return null;
        }
    },

    listarDecisoes: async (esteiraId: number): Promise<IFgtsConciliacaoDecisao[]> => {
        const resp = await api.get(`fgts-conciliacao/${esteiraId}/decisoes`);
        return resp.data;
    },

    listarAuditoria: async (esteiraId: number): Promise<IFgtsAuditoriaEvento[]> => {
        const resp = await api.get(`fgts-conciliacao/${esteiraId}/auditoria`);
        return resp.data;
    },

    aceitarSugestao: async (esteiraId: number, chaveVinculoMatch: string): Promise<void> => {
        await api.patch(`fgts-conciliacao/${esteiraId}/sugestoes/${chaveVinculoMatch}/aceitar`);
    },

    recusarSugestao: async (esteiraId: number, chaveVinculoMatch: string): Promise<void> => {
        await api.patch(`fgts-conciliacao/${esteiraId}/sugestoes/${chaveVinculoMatch}/recusar`);
    },
};

export default FgtsConciliacaoService;
